// OptionsContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';

export const OptionsContext = createContext();

export function OptionsProvider({ children }) {
  const [options, setOptions] = useState({});
  const [optionsByPayment, setOptionsByPayment] = useState({ cash: {}, noncash: {}, default: {} });
  // Значение контекста собиралось заново на каждый рендер провайдера, и вместе с
  // ним перерисовывались все потребители — «Товары», сравнение производств, расчёт
  // заказа, — даже когда номенклатура не менялась.
  const value = useMemo(
    () => ({ options, setOptions, optionsByPayment, setOptionsByPayment }),
    [options, optionsByPayment]
  );
  return (
    <OptionsContext.Provider value={value}>
      {children}
    </OptionsContext.Provider>
  );
}

export const useOptions = () => useContext(OptionsContext);